import { filterTreeData } from './DataAccessUtils';

export type ApplyLocalAnalyticsTreeFiltersOptions = {
	selectedIds?: Array<number | string>;
	search?: string;
};

/**
 * Client-side tree filters used on analytics breakdown pages (location / problem-type trees).
 * Comparison API responses must pass through this before normalization so previous-period
 * rows match the user's current search and ID selection.
 */
export const applyLocalAnalyticsTreeFilters = (
	treeData: any[],
	options: ApplyLocalAnalyticsTreeFiltersOptions = {}
): any[] => {
	const selectedIds = (options && options.selectedIds) || [];
	const search = (options && options.search) || '';
	let filtered = treeData || [];

	if (selectedIds.length > 0) {
		filtered = filterTreeData(filtered, (obj) => selectedIds.includes(obj.id));
	}

	const trimmedSearch = search.trim();
	if (trimmedSearch) {
		const searchLower = trimmedSearch.toLowerCase();
		filtered = filterTreeData(
			filtered,
			(obj) => obj.name && obj.name.toLowerCase().includes(searchLower)
		);
	}

	return filtered;
};
